import * as Configuration from "./Configuration"

// tmp fix for scripts that should import Configuration instead of use global property
window.Fnac = window.Fnac || {};
let warnGlobalConfigUsage = true;
Object.defineProperty(Fnac, "config", {
  get: () => {
    if(warnGlobalConfigUsage){
      console.warn("Use global Fnac.config is depreciated, use 'import {isMobile} from \"..../Configuration\";' instead.");
    }
    warnGlobalConfigUsage = false;
    return Configuration;
  }
});

let warnGlobalViewsUsage = true;
Object.defineProperty(Fnac, "Views", {
  get: () => {
    if(warnGlobalViewsUsage){
      console.warn("Use Fnac.Views is depreciated, use 'import {MyView} from \"..../MyView\";' instead.");
    }
    warnGlobalViewsUsage = false;
    return {};
  }
});
